import { stringHelper } from './string'
import { store } from '../index'

export const cdnHelper = {
  getFileUrl,
  getResizeUrl,
}

function getFileUrl (url) {
  if (!url) {
    return null
  }
  // eslint-disable-next-line no-param-reassign
  const imageUrl = stringHelper.replaceAll(`/${url}`, '//', '/')
  const { mediaBaseUrl } = store.getState().app && store.getState().app.appConfig ? store.getState().app.appConfig : {}
  return `${mediaBaseUrl}${imageUrl}`
}

function getResizeUrl (url, size) {
  if (!url) {
    return null
  }
  if (!size) {
    return url
  }
  // eslint-disable-next-line no-param-reassign
  const imageUrl = stringHelper.replaceAll(url, '//', '/')
  const { mediaResizeUrl } = store.getState().app && store.getState().app.appConfig ? store.getState().app.appConfig : {}
  return `${mediaResizeUrl}/${size}${imageUrl}`
}
